import { render } from "./StandardAppLayout.vue?vue&type=template&id=31904961"
import script from "./StandardAppLayout.vue?vue&type=script&lang=js"
export * from "./StandardAppLayout.vue?vue&type=script&lang=js"

import "./StandardAppLayout.vue?vue&type=style&index=0&id=31904961&lang=scss"
script.render = render

export default script